// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.festivals {
  padding: 2rem 0;
  background-color: var(--color-white);
}

.festivals-title {
  text-align: center;
  margin-bottom: 3rem;
}

.festivals-title h2 {
  color: var(--color-text-primary);
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
}

.festivals-grid {
  display: flex;
  height: 550px;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
  gap: 10px;
}

.festival-item {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: flex 0.6s ease;
}

.festival-item:hover {
  flex: 3 1;
}

/* Color overlay with blur effect */
.festival-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1;
  transition: opacity 0.3s ease;
}

.festival-item:hover .festival-overlay {
  opacity: 0;
}

/* Festival Logo - Default State */
.festival-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 140px;
  height: auto;
  z-index: 2;
  transition: opacity 0.3s ease;
}

.festival-logo img {
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: 105px;
}

.festival-item:hover .festival-logo {
  opacity: 0;
}

/* Festival Background - Always visible */
.festival-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.festival-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.5);
}



.festival-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--color-text-primary);
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.4s ease 0.2s;
  z-index: 2;
}

.festival-item:hover .festival-content {
  opacity: 1;
  transform: translateX(0);
}

.festival-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 25% 1rem 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.2;
}

.festival-description {
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0 25% 2rem 0;
  opacity: 0.9;
}

.festival-button {
  background-color: transparent;
  color: var(--color-text-primary);
  padding: 0.45rem 0.9rem;
  text-decoration: none;
  border-radius: 180px;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  border: 2px solid var(--color-text-primary);
  position: absolute;
  bottom: 2rem;
  right: 2rem;
}

.festival-button:hover {
  background-color: var(--color-text-primary);
  color: var(--color-text-dark);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .festivals-grid {
    padding: 0 1rem;
    height: 350px;
  }
  
  .festival-content {
    padding: 1.5rem;
  }
  
  .festival-title {
    font-size: 1.3rem;
    margin: 0 5% 1rem 0;
  }
  
  .festival-description {
    font-size: 1rem;
    margin: 0 5% 2rem 0;
  }
  
  .festival-button {
    bottom: 1.5rem;
    right: 1.5rem;
    padding: 0.35rem 0.7rem;
  }
}

@media (max-width: 768px) {
  .festivals {
    padding: 2rem 1rem;
  }
  
  .festivals-grid {
    padding: 0;
    height: auto;
    flex-direction: column;
    gap: 1rem;
  }
  
  .festival-item {
    flex: none;
    width: 100%;
    height: 300px;
    transition: height 0.6s ease;
  }
  
  .festival-item:hover,
  .festival-item:focus,
  .festival-item.expanded {
    height: 600px;
  }
  
  .festival-logo {
    width: 130px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  .festival-logo img {
    max-height: 95px;
  }
  
  .festival-background {
    width: 100%;
    height: 300px;
    position: relative;
    transition: height 0.6s ease;
  }
  
  .festival-item:hover .festival-background,
  .festival-item:focus .festival-background,
  .festival-item.expanded .festival-background {
    height: 600px;
  }
  
  .festival-background::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
  }
  
  .festival-item:hover .festival-background::after,
  .festival-item:focus .festival-background::after,
  .festival-item.expanded .festival-background::after {
    opacity: 1;
  }
  
  .festival-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: all 0.4s ease 0.2s;
    transform: translateX(-20px);
    z-index: 2;
  }
  
  .festival-item:hover .festival-content,
  .festival-item:focus .festival-content,
  .festival-item.expanded .festival-content {
    opacity: 1;
    transform: translateX(0);
  }
  
  .festival-title {
    font-size: 1.1rem;
    margin: 0 0 1rem 0;
  }
  
  .festival-description {
    font-size: 1.2rem;
    margin: 0 0 1rem 0;
  }
  
  .festival-button {
    position: static;
    margin-top: 1rem;
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
    width: fit-content;
  }
  
  .festivals-title h2 {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .festival-item {
    height: 300px;
  }
  
  .festival-item:hover,
  .festival-item:focus,
  .festival-item.expanded {
    height: 400px;
  }
  
  .festival-logo {
    width: 110px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  .festival-logo img {
    max-height: 80px;
  }
  
  .festival-background {
    height: 300px;
  }
  
  .festival-item:hover .festival-background,
  .festival-item:focus .festival-background,
  .festival-item.expanded .festival-background {
    height: 400px;
  }
  
  .festival-content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .festival-title {
    font-size: 0.9rem;
    line-height: 1.1;
    margin-bottom: 0.5rem;
  }
  
  .festival-description {
    font-size: 1em;
    margin-bottom: 0.75rem;
    line-height: 1.3;
  }
  
  .festival-button {
    padding: 0.6rem 1.2rem;
    font-size: 0.8rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Festivals/Festivals.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAO;AACT;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,4BAA4B;EAC5B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;IACb,4BAA4B;EAC9B;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,UAAU;IACV,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;;;IAGE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,8BAA8B;IAC9B,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;;;IAGE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF","sourcesContent":[".festivals {\n  padding: 2rem 0;\n  background-color: var(--color-white);\n}\n\n.festivals-title {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.festivals-title h2 {\n  color: var(--color-text-primary);\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.festivals-grid {\n  display: flex;\n  height: 550px;\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  gap: 10px;\n}\n\n.festival-item {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: flex 0.6s ease;\n}\n\n.festival-item:hover {\n  flex: 3;\n}\n\n/* Color overlay with blur effect */\n.festival-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 1;\n  transition: opacity 0.3s ease;\n}\n\n.festival-item:hover .festival-overlay {\n  opacity: 0;\n}\n\n/* Festival Logo - Default State */\n.festival-logo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 140px;\n  height: auto;\n  z-index: 2;\n  transition: opacity 0.3s ease;\n}\n\n.festival-logo img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  max-height: 105px;\n}\n\n.festival-item:hover .festival-logo {\n  opacity: 0;\n}\n\n/* Festival Background - Always visible */\n.festival-background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n}\n\n.festival-background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: brightness(0.5);\n}\n\n\n\n.festival-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  color: var(--color-text-primary);\n  opacity: 0;\n  transform: translateX(-20px);\n  transition: all 0.4s ease 0.2s;\n  z-index: 2;\n}\n\n.festival-item:hover .festival-content {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.festival-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 25% 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  line-height: 1.2;\n}\n\n.festival-description {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin: 0 25% 2rem 0;\n  opacity: 0.9;\n}\n\n.festival-button {\n  background-color: transparent;\n  color: var(--color-text-primary);\n  padding: 0.45rem 0.9rem;\n  text-decoration: none;\n  border-radius: 180px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n  border: 2px solid var(--color-text-primary);\n  position: absolute;\n  bottom: 2rem;\n  right: 2rem;\n}\n\n.festival-button:hover {\n  background-color: var(--color-text-primary);\n  color: var(--color-text-dark);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .festivals-grid {\n    padding: 0 1rem;\n    height: 350px;\n  }\n  \n  .festival-content {\n    padding: 1.5rem;\n  }\n  \n  .festival-title {\n    font-size: 1.3rem;\n    margin: 0 5% 1rem 0;\n  }\n  \n  .festival-description {\n    font-size: 1rem;\n    margin: 0 5% 2rem 0;\n  }\n  \n  .festival-button {\n    bottom: 1.5rem;\n    right: 1.5rem;\n    padding: 0.35rem 0.7rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .festivals {\n    padding: 2rem 1rem;\n  }\n  \n  .festivals-grid {\n    padding: 0;\n    height: auto;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .festival-item {\n    flex: none;\n    width: 100%;\n    height: 300px;\n    transition: height 0.6s ease;\n  }\n  \n  .festival-item:hover,\n  .festival-item:focus,\n  .festival-item.expanded {\n    height: 600px;\n  }\n  \n  .festival-logo {\n    width: 130px;\n    height: auto;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n  .festival-logo img {\n    max-height: 95px;\n  }\n  \n  .festival-background {\n    width: 100%;\n    height: 300px;\n    position: relative;\n    transition: height 0.6s ease;\n  }\n  \n  .festival-item:hover .festival-background,\n  .festival-item:focus .festival-background,\n  .festival-item.expanded .festival-background {\n    height: 600px;\n  }\n  \n  .festival-background::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    z-index: 1;\n  }\n  \n  .festival-item:hover .festival-background::after,\n  .festival-item:focus .festival-background::after,\n  .festival-item.expanded .festival-background::after {\n    opacity: 1;\n  }\n  \n  .festival-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    opacity: 0;\n    transition: all 0.4s ease 0.2s;\n    transform: translateX(-20px);\n    z-index: 2;\n  }\n  \n  .festival-item:hover .festival-content,\n  .festival-item:focus .festival-content,\n  .festival-item.expanded .festival-content {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  \n  .festival-title {\n    font-size: 1.1rem;\n    margin: 0 0 1rem 0;\n  }\n  \n  .festival-description {\n    font-size: 1.2rem;\n    margin: 0 0 1rem 0;\n  }\n  \n  .festival-button {\n    position: static;\n    margin-top: 1rem;\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n    width: fit-content;\n  }\n  \n  .festivals-title h2 {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .festival-item {\n    height: 300px;\n  }\n  \n  .festival-item:hover,\n  .festival-item:focus,\n  .festival-item.expanded {\n    height: 400px;\n  }\n  \n  .festival-logo {\n    width: 110px;\n    height: auto;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n  .festival-logo img {\n    max-height: 80px;\n  }\n  \n  .festival-background {\n    height: 300px;\n  }\n  \n  .festival-item:hover .festival-background,\n  .festival-item:focus .festival-background,\n  .festival-item.expanded .festival-background {\n    height: 400px;\n  }\n  \n  .festival-content {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .festival-title {\n    font-size: 0.9rem;\n    line-height: 1.1;\n    margin-bottom: 0.5rem;\n  }\n  \n  .festival-description {\n    font-size: 1em;\n    margin-bottom: 0.75rem;\n    line-height: 1.3;\n  }\n  \n  .festival-button {\n    padding: 0.6rem 1.2rem;\n    font-size: 0.8rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
